import React from 'react';
import { Text, ProgressBar, Icon, DatePicker } from '../../Atoms';
import {
  Input,
  AffiliationRecapMolecule,
  AffiliationButtonMolecule,
  Upload
} from '../../Molecules';
import { pink, white } from '../../Config/Config';
function OrganismAffiliationStage5 (props) {
  return (
    <div className='organism-affilation-stage1-container'>
      <Text
        text='Complétez votre affiliation'
        className='organism-affiliation-stage1-title'
      />
      <Text
        text={`Etape ${props.stage} / 5`}
        className='organism-affiliation-stage1-stage'
      />
      <ProgressBar
        percent={`${((props.stage * 100) / 5).toString()}%`}
        height='15px'
        backgroundColor={white}
        backgroundColorFulFilled={pink}
        containerClassName='organism-affiliation-stage1-progressBar'
      />
      <div>
        <div className='organism-affiliation-form-container organism-affiliation-stage5-form-container '>
          <Text
            text='Informations personnelles'
            className='organism-affiliation-stage1-personal-info'
          />
          <div className='organism-affiliation-stage5-document-container'>
            <Text text='Merci de bien vouloir nous transmettre les documents suivants' />
            <div>
              LESIRE Alba : <span>Attestation vitale</span>
            </div>
            <div>
              LESIRE Enzo : <span>Justificatif d’activité</span>
            </div>
          </div>
          <div className='organism-affiliation-stage5-document-container'>
            <Text text="Pour votre enfant de plus de 18 ans, veuillez joindre l'une des pièces justificatives suivante :" />
            <Text
              text='Certificat de scolarité si poursuite d’études'
              className='organism-affiliation-stage5-list-item'
            />
            <Text
              text='Copie du contrat en cas de contrat d’apprentissage, professionnalisation, ou d’accompagnement à l’emploi'
              className='organism-affiliation-stage5-list-item'
            />
            <Text
              text='Attestation d’inscription à Pole Emploi en cas de recherche d’emploi inscrit à Pole emploi'
              className='organism-affiliation-stage5-list-item'
            />
            <Text
              text='Copie de son dernier bulletin de salaire en cas d’activité professionnelle avec une rémunération inferieure à la moitié du smic'
              className='organism-affiliation-stage5-list-item'
            />
          </div>
          <div className='organism-affiliation-stage1-recap-container organism-affiliation-stage5-upload-container'>
            <Upload
              handleFileChange={() => {}}
              contentClassName='organism-affiliation-stage5-upload'
              classNameFileInputContainer='organism-affiliation-stage5-upload-file-input'
            />
          </div>
          <div className='organism-affiliation-stage5-document-container organism-affiliation-stage5-affiliation-finished-container'>
            <div className='organism-affiliation-stage5-affiliation-finished-icon-container'>
              <Icon icon='Attention' size='22px' color='#1313C6' />
            </div>
            <div>
              Une fois votre affiliation terminée, vous allez être dirigé vers
              le site Universign.<br></br>
              Suite à la signature électronique,{' '}
              <span>
                merci d&apos;attendre la redirection vers votre Espace<br></br>
                Assuré avant de quitter la page.
              </span>
            </div>
          </div>
        </div>
      </div>
      <AffiliationButtonMolecule
        confirmerClicked={props.confirmerClicked}
        goBackClicked={props.goBackClicked}
        stage={props.stage}
      />
    </div>
  );
}

export default OrganismAffiliationStage5;
